import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { Info } from "lucide-react";

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    const val = payload[0].value;
    const timeLabel = label || payload[0]?.payload?.date || "";
    return (
      <div className="bg-slate-900/95 backdrop-blur-md text-white px-3 py-2 rounded-xl text-xs shadow-xl border border-slate-700/60 select-none outline-none">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-emerald-400 shrink-0"></span>
          <span className="font-bold text-white whitespace-nowrap">
            {timeLabel ? `${timeLabel} • ` : ""}{val} {val === 1 ? "Booking" : "Bookings"}
          </span>
        </div>
      </div>
    );
  }
  return null;
};

const RechartsLineChart = ({ data }: any) => {
  const chartData = Array.isArray(data) && data.length > 0
    ? data
    : [];

  return (
    <div className="w-full">
      <div className="w-full h-[280px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={chartData}
            margin={{
              top: 20,
              right: 20,
              left: -15,
              bottom: 5,
            }}
          >
            <defs>
              <linearGradient id="readyShareGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#006747" stopOpacity={0.25} />
                <stop offset="65%" stopColor="#006747" stopOpacity={0.06} />
                <stop offset="100%" stopColor="#006747" stopOpacity={0.0} />
              </linearGradient>
            </defs>

            <CartesianGrid
              strokeDasharray="4 4"
              stroke="#e2e8f0"
              vertical={false}
            />

            <XAxis
              dataKey="date"
              tick={{ fill: "#64748b", fontSize: 11, fontWeight: 500 }}
              axisLine={{ stroke: "#e2e8f0" }}
              tickLine={false}
              dy={6}
            />

            <YAxis
              tick={{ fill: "#94a3b8", fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              allowDecimals={false}
              dx={-4}
            />

            <Tooltip
              content={<CustomTooltip />}
              wrapperStyle={{ outline: "none", border: "none" }}
              cursor={{ stroke: "#94a3b8", strokeWidth: 1, strokeDasharray: "4 4" }}
            />

            {/* Main Area curve */}
            <Area
              type="monotone"
              dataKey="total_bookings"
              name="Total Bookings"
              stroke="#006747"
              strokeWidth={2.5}
              fill="url(#readyShareGradient)"
              dot={{
                r: 4,
                fill: "#ffffff",
                stroke: "#006747",
                strokeWidth: 2,
              }}
              activeDot={{
                r: 6.5,
                fill: "#006747",
                stroke: "#ffffff",
                strokeWidth: 2.5,
              }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RechartsLineChart;
